/* Cuidados Mascotiles · interacciones de las secciones propias */
(() => {
  document.documentElement.classList.add("cm-js");

  function iniciarRevelado(raiz) {
    const elementos = raiz.querySelectorAll(".cm-revelar:not(.cm-visible)");
    if (!("IntersectionObserver" in window)) {
      elementos.forEach((el) => el.classList.add("cm-visible"));
      return;
    }
    const observador = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((entrada) => {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add("cm-visible");
          observador.unobserve(entrada.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px" },
    );
    elementos.forEach((el, i) => {
      el.style.transitionDelay = `${(i % 4) * 60}ms`;
      observador.observe(el);
    });
  }

  function iniciarFiltros(raiz) {
    raiz.querySelectorAll("[data-cm-catalogo]").forEach((catalogo) => {
      const botones = catalogo.querySelectorAll("[data-cm-filtro]");
      const tarjetas = catalogo.querySelectorAll("[data-cm-filtros]");
      const estado = catalogo.querySelector("[data-cm-estado]");
      const aplicar = (valor) => {
        let visibles = 0;
        botones.forEach((b) =>
          b.setAttribute("aria-pressed", String(b.dataset.cmFiltro === valor)),
        );
        tarjetas.forEach((tarjeta) => {
          const mostrar =
            valor === "todos" ||
            tarjeta.dataset.cmFiltros.split(" ").includes(valor);
          tarjeta.hidden = !mostrar;
          if (mostrar) {
            visibles++;
            tarjeta.classList.add("cm-visible");
          }
        });
        if (estado) estado.textContent = `${visibles} productos`;
      };
      botones.forEach((b) =>
        b.addEventListener("click", () => aplicar(b.dataset.cmFiltro)),
      );
    });
  }

  function iniciarPestanas(raiz) {
    raiz.querySelectorAll("[data-cm-pestanas]").forEach((grupo) => {
      const pestanas = [...grupo.querySelectorAll('[role="tab"]')];
      const activar = (pestana) => {
        pestanas.forEach((p) => {
          const activa = p === pestana;
          p.setAttribute("aria-selected", String(activa));
          p.tabIndex = activa ? 0 : -1;
          const panel = document.getElementById(
            p.getAttribute("aria-controls"),
          );
          if (panel) panel.hidden = !activa;
        });
      };
      pestanas.forEach((p, i) => {
        p.addEventListener("click", () => activar(p));
        p.addEventListener("keydown", (e) => {
          if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
          const paso = e.key === "ArrowRight" ? 1 : pestanas.length - 1;
          const siguiente = pestanas[(i + paso) % pestanas.length];
          activar(siguiente);
          siguiente.focus();
        });
      });
    });
  }

  function iniciar(raiz) {
    iniciarRevelado(raiz);
    iniciarFiltros(raiz);
    iniciarPestanas(raiz);
  }

  /* Releasit (plan gratis) no deja traducir algunas etiquetas del resumen. */
  const TEXTOS_RELEASIT = { Discounts: "Descuento", Discount: "Descuento" };

  function traducirReleasit() {
    document
      .querySelectorAll(".rsi-total-summary-label")
      .forEach((etiqueta) => {
        const traduccion = TEXTOS_RELEASIT[etiqueta.textContent.trim()];
        if (traduccion) etiqueta.textContent = traduccion;
      });
  }

  iniciar(document);
  document.addEventListener("shopify:section:load", (e) => iniciar(e.target));
  new MutationObserver(traducirReleasit).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
